<template>
    <div class="list-group-item">
        <div class="row">
            <div class="col col-md-12">
                {{ map.handler }}
            </div>
            <div class="col col-md-12">
                {{ map.affiliate.name }}
            </div>
            <div class="col col-md-12">
                <span style="white-space: pre;">{{ map.api_key }}</span>
            </div>
            <div class="col col-md-12">
                <button class="btn btn-danger" :disabled="deleter.submitted" @click="triggerDelete()">
                     Ta bort
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import deleter from '../../shared/mixins/deleter'
export default {

    mixins: [
        deleter
    ],

    props: {
        product: {
            required: true
        },
        map: {
            required: true
        }
    },

    data () {
        return {
            affiliate_id: null,
            api_key: '',

            error: false
        }
    },

    computed: {
        deleterUrl () {
            return '/products/' + this.product.id + '/apiMap/' + this.map.id
        }
    },

    methods: {

        triggerDelete () {
            if (!confirm('Är du säker?')) {
                return
            }
            this.deleterDelete()
        },

        deleterSuccess () {
            bus.$emit('notify', 'API kopplingen har tagits bort')
            this.$emit('refresh')
        }
    }

}
</script>
